import { Effect } from 'effect';
import { isSSR } from '@/env';

const ssrBudget = '2 seconds';

/**
 * Waits for a loader's reads. The server sends nothing until the loaders
 * settle, so a slow API would leave a blank tab: past the budget the server
 * stops waiting, the reads keep running, and the page renders what it has.
 */
export const awaitWithinSsrBudget = (reads: Promise<unknown>) => {
  const wait = Effect.promise(() => reads).pipe(Effect.asVoid);
  return Effect.runPromise(
    isSSR
      ? Effect.timeoutOrElse(wait, {
          duration: ssrBudget,
          orElse: () => Effect.void,
        })
      : wait,
  );
};
